import { Booking } from '../../types/booking';

// Importing Booking related action types.
import { BookingActionTypes } from '../actions/bookingActions';

// Defining the shape of the state for bookings.
interface BookingState {
    getBookings: Booking[];
}

// The initial state of the booking feature.
const initialState: BookingState = {
    getBookings: [],
};

// Reducer function for handling booking-related actions.
const bookingReducer = (
  state = initialState,
  action: BookingActionTypes
): BookingState => { 
  switch (action.type) {
    case 'ADD_BOOKING':
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          getBookings: action.payload,
        };
      }

      if (Object.keys(state).length) {
        const newBooking = action.payload;
        const existingIndex = state.getBookings.findIndex(
          (booking: Booking) => booking.id === newBooking.id
        );

        if (existingIndex === -1) {
          return {
            ...state,
            getBookings: [...state.getBookings, newBooking],
          };
        }

        const updatedBookings = [...state.getBookings];
        updatedBookings[existingIndex] = newBooking;

        return {
          ...state,
          getBookings: updatedBookings,
        };
      }

      return { getBookings: [] };
    case 'UPDATE_BOOKING':
      // Update a specific booking based on the payload.
      return {
        ...state,
        getBookings: state.getBookings.map(booking =>
          booking.id === action.payload.id ? action.payload : booking
        ),
      };
      
    case 'DELETE_BOOKING':
      // Remove a booking from the state based on the payload.
      return {
        ...state,
        getBookings: state.getBookings.filter(booking => booking.id+"" !== action.payload),
      };
      
    default:
      // Return the current state if no actions match.
      return state;
  }
};

// Exporting the booking reducer.
export default bookingReducer;
